module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/kobe_concept_01-c761d70681dfa836f432e3573e9ea64a.jpg";